import React, { useState } from "react";
import { useEffect } from "react";
import { useCookies } from "react-cookie";

const LanguageChange = () => {
  const [cookies, setCookie] = useCookies();

  let flag = 0;
  useEffect(() => {
    if (flag === 0) {
      flag = flag + 1;
      const getCookie = (name) => {
        const match = document.cookie.match(
          new RegExp("(^| )" + name + "=([^;]+)")
        );
        return match ? match[2] : null;
      };

      const setDefaultLanguageToSpanish = () => {
        const currentTrans = getCookie("googtrans");
        if (!currentTrans) {
          document.cookie = "googtrans=/en/en;path=/;max-age=31536000";
        }
      };

      const addGoogleTranslateScript = () => {
        const script = document.createElement("script");
        script.src =
          "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        script.async = true;
        document.body.appendChild(script);
      };

      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,hi,ml,ta,te",
            layout: "google.translate.TranslateElement.InlineLayout.SIMPLE",
          },
          "google_translate_element"
        );
      };

      setDefaultLanguageToSpanish();

      if (window.google && window.google.translate) {
        window.googleTranslateElementInit();
      } else {
        addGoogleTranslateScript();
      }
    }
  }, []);

  return (
    <div className="language-option">
      <div id="google_translate_element" />
    </div>
  );
};

export default LanguageChange;
